import { FrontpageService } from '../../Services/frontpage.service';
import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import * as $ from 'jquery';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-home-card-show',
  template: require('./home-card-show.component.html'),
  styles: [require('./home-card-show.component.css')]
})
export class HomeCardShowComponent implements OnInit {
  @Input('position') position: string;
  
  items : any[] = [];
  
  videoWidth = "340";
  
  constructor(private frontPageService: FrontpageService, private auth: AuthService) { }



  ngOnInit() {
    switch (this.position) {
      case "left":
        this.videoWidth = '340';
        break;
      case 'right':
        this.videoWidth = '248';
      default:
        break;
    }
    this.refreshAll();
  }

  refreshAll(){
    this.frontPageService.getAllFrontPageItems(this.position).subscribe(res => {
        this.items = res;
    });
  }

  deleteOtherItem(i: number) {
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          var index = this.items.findIndex(x => x.id==i);
          this.items.splice(index, 1);
          this.frontPageService.delete(i).subscribe(res =>{
          
          });
        }
      });
  }

  getFilenameType(filename: string){
    var ext = "";
    var res = ""
    if (filename.length > 0){
      ext = filename.substr(filename.lastIndexOf('.')+1,4).toLowerCase()
      switch (ext) {
        case "mp4":
          res = "video";        
          break;
        case "":
          res =  "none";
          break;
        
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          res =  "image";
          break;
        default:
          res =  "none"
          break;
      }
    }
    return res;

  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/home-card-show/home-card-show.component.ts